import { Box, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  CartesianGrid,
  LineChart,
  Tooltip,
  XAxis,
  Line,
  YAxis,
} from "recharts";
import { useContextDashboardBrokerContext } from "src/Contexts/Dashboard/ContextDashboardBroker";
import { CardCore } from "src/Pages/components/CardCore/CardCore";

import { FormInstallmentsReceived } from "./Form";
import { CustomTooltipInstallments } from "./CustomTooltip";

const COLORS = {
  all: "#4361EE",
  primary: "#06D6A0",
  grid: "#F1F1F4",
  axis: "#9CA3AF",
};

const LegendBadge = ({ color, label, value, }: {
  color: string;
  label: string;
  value: number;
}) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Box
      sx={{
        width: 10,
        height: 10,
        borderRadius: "50%",
        backgroundColor: color,
      }}
    />
    <Typography
      sx={{ fontSize: "0.85rem", color: "#6B7280", fontWeight: 500 }}
    >
      {label}
    </Typography>
    <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color }}>
      {value}
    </Typography>
  </Box>
);

export const InstallmentsReceived = () => {
  const { dataInstallmentsReceivedCombined } = useContextDashboardBrokerContext();

  const { totalAll, totalPrimary } = dataInstallmentsReceivedCombined.meta;

  return (
    <CardCore sxStyle={{ margin: "1rem 0", marginBottom: "24px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
          <Typography sx={{ fontSize: "1rem", fontWeight: 600 }}>
            Parcelas
          </Typography>
          <LegendBadge
            color={COLORS.all}
            label="Confirmadas"
            value={totalAll || 0}
          />
          <LegendBadge
            color={COLORS.primary}
            label="Primeira parcela"
            value={totalPrimary || 0}
          />
        </Box>

        <FormInstallmentsReceived />
      </Box>

      <ResponsiveContainer height={320} width="100%">
        <LineChart
          data={dataInstallmentsReceivedCombined.data}
          margin={{ top: 8, right: 8, left: -20, bottom: 0 }}
        >
          <defs>
            <linearGradient id="gradAll" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={COLORS.all} stopOpacity={0.12} />
              <stop offset="100%" stopColor={COLORS.all} stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gradPrimary" x1="0" y1="0" x2="0" y2="1">
              <stop
                offset="0%"
                stopColor={COLORS.primary}
                stopOpacity={0.12}
              />
              <stop
                offset="100%"
                stopColor={COLORS.primary}
                stopOpacity={0}
              />
            </linearGradient>
          </defs>

          <CartesianGrid
            horizontal
            stroke={COLORS.grid}
            strokeDasharray="4 4"
            vertical={false}
          />

          <XAxis
            axisLine={false}
            dataKey="label"
            dy={8}
            fontSize={12}
            stroke={COLORS.axis}
            tickLine={false}
          />
          <YAxis
            axisLine={false}
            fontSize={12}
            stroke={COLORS.axis}
            tickLine={false}
          />

          <Tooltip
            content={<CustomTooltipInstallments />}
            cursor={{ stroke: COLORS.axis, strokeDasharray: "4 4" }}
          />

          <Line
            activeDot={{ r: 5, strokeWidth: 2, fill: "#fff" }}
            dataKey="valueAll"
            dot={false}
            name="Confirmadas"
            stroke={COLORS.all}
            strokeWidth={2.5}
            type="monotone"
          />

          <Line
            activeDot={{ r: 5, strokeWidth: 2, fill: "#fff" }}
            dataKey="valuePrimary"
            dot={false}
            name="Primeira parcela"
            stroke={COLORS.primary}
            strokeWidth={2.5}
            type="monotone"
          />
        </LineChart>
      </ResponsiveContainer>
    </CardCore>
  );
};
